import React, { Fragment } from "react";
import NotificationSystem from "react-notification-system";
import {
  Card,
  CardBody,
  CardImg,
  Col,
  Row,
  Table,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from "react-sortable-hoc";
import { GrDrag } from "react-icons/gr";
import { MdEdit, MdDeleteForever } from "react-icons/md";
import styled from "styled-components";
import Page from "../components/Page";
import RushNewsEdit from "./RushNewsEdit";
import PageSpinner from "../components/PageSpinner";

import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";

import * as Server from "../Server";

let selectedNewsId = null;
class RushNews extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      news: {},
      rushNews: [],
      editNews: false,
      showLoader: false,
      rushNewsEditPage: false,
      removeNewsConfirmationModal: false,
    };
  }

  componentDidMount() {
    this.getRushNewsList();
  }

  getRushNewsList = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/news/list",
        method: "GET",
      });
      if (response) {
        this.setState({
          showLoader: false,
          rushNews: response.news,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  removeRushNews = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: `rushsoccer/news/delete?newsId=${selectedNewsId}`,
        method: "DELETE",
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "error",
        });
        this.getRushNewsList();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateOrder = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/news/changeorder",
        method: "POST",
        data: { rushNews: this.state.rushNews },
      });
      if (response) {
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.setState({
          showLoader: false,
        });
        this.getRushNewsList();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  toggleremoveRushNewsConfirmationModal = async (id) => {
    if (id) selectedNewsId = id;
    this.setState({
      removeNewsConfirmationModal: !this.state.removeNewsConfirmationModal,
    });
  };

  renderRushNewsEditPage = (news, key) => {
    this.setState({
      news,
      rushNewsEditPage: true,
      editNews: key,
    });
  };

  closeModal = async () => {
    this.setState({ productDetailModal: false });
  };

  closeRushNewsEditPage = async (obj) => {
    this.setState({ rushNewsEditPage: false });
    if (obj.refreshList) {
      this.getRushNewsList();
    }
  };

  SortableCont = SortableContainer(({ children }) => {
    return <tbody>{children}</tbody>;
  });

  SortableItem = SortableElement((props) => <TableRow {...props} />);

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.arrayMove(this.state.rushNews, oldIndex, newIndex);
  };

  arrayMoveMutate = (array, from, to) => {
    array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
  };

  arrayMove = (array, from, to) => {
    array = array.slice();
    this.arrayMoveMutate(array, from, to);
    this.setState({ rushNews: array });
    return array;
  };

  render() {
    return (
      <Fragment>
        {this.state.rushNewsEditPage ? (
          <RushNewsEdit
            news={this.state.news}
            editNewsKey={this.state.editNews}
            closeRushNewsEditPage={(event) => this.closeRushNewsEditPage(event)}
          ></RushNewsEdit>
        ) : (
          <div>
            <PageSpinner showLoader={this.state.showLoader} />
            <Page title="News" breadcrumbs={[{ name: "News", active: true }]}>
              <Row>
                <Col>
                  <Card>
                    <CardBody>
                      <Button
                        onClick={(event) => this.updateOrder(event)}
                        style={{ float: "right", marginBottom: "10px" }}
                      >
                        Update Order
                      </Button>
                      <Button
                        style={{
                          float: "right",
                          marginBottom: "10px",
                          marginRight: "10px",
                        }}
                        onClick={(event) =>
                          this.renderRushNewsEditPage({}, false)
                        }
                      >
                        Add News
                      </Button>

                      <Table striped hover responsive>
                        <thead>
                          <tr>
                            <th></th>
                            <th>Image</th>
                            <th>Name</th>
                            <th>Url</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        {this.state.rushNews &&
                        this.state.rushNews.length > 0 ? (
                          <this.SortableCont
                            onSortEnd={this.onSortEnd}
                            axis="y"
                            lockAxis="y"
                            lockToContainerEdges={true}
                            lockOffset={["30%", "50%"]}
                            helperClass="helperContainerClass"
                            useDragHandle={true}
                          >
                            {this.state.rushNews.map((news, index) => (
                              <this.SortableItem
                                key={`item-${index}`}
                                index={index}
                                Image={
                                  <CardImg
                                    key={index}
                                    src={news.imageUrl}
                                    alt=""
                                    className="img-responsive"
                                    style={{ width: 100 }}
                                  />
                                }
                                Name={news.name}
                                Url={news.url}
                                Action={
                                  <div>
                                    <Button
                                      style={{ marginRight: "10px" }}
                                      onClick={(event) => {
                                        this.renderRushNewsEditPage(news, true);
                                      }}
                                    >
                                      <MdEdit size="20px" />
                                    </Button>
                                    <Button
                                      style={{
                                        marginRight: "10px",
                                      }}
                                      onClick={(event) =>
                                        this.toggleremoveRushNewsConfirmationModal(
                                          news._id
                                        )
                                      }
                                    >
                                      <MdDeleteForever size="20px" />
                                    </Button>
                                  </div>
                                }
                              />
                            ))}
                          </this.SortableCont>
                        ) : (
                          <tr>
                            <td colSpan="7" className="text-center">
                              No news found
                            </td>
                          </tr>
                        )}
                      </Table>
                    </CardBody>
                    {this.state.removeNewsConfirmationModal ? (
                      <Modal
                        isOpen={this.state.removeNewsConfirmationModal}
                        toggle={(event) =>
                          this.toggleremoveRushNewsConfirmationModal()
                        }
                        className="modal-md"
                      >
                        <ModalHeader
                          toggle={(event) =>
                            this.toggleremoveRushNewsConfirmationModal()
                          }
                        ></ModalHeader>
                        <ModalBody>
                          Are you sure you want to delete this news ?
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            color="secondary"
                            onClick={(event) =>
                              this.toggleremoveRushNewsConfirmationModal()
                            }
                          >
                            Cancel
                          </Button>
                          <Button
                            color="primary"
                            onClick={(event) => {
                              this.toggleremoveRushNewsConfirmationModal();
                              this.removeRushNews();
                            }}
                          >
                            Delete
                          </Button>
                        </ModalFooter>
                      </Modal>
                    ) : null}
                  </Card>
                </Col>
              </Row>
              <NotificationSystem
                dismissible={false}
                ref={(notificationSystem) =>
                  (this.notificationSystem = notificationSystem)
                }
                style={NOTIFICATION_SYSTEM_STYLE}
              />
            </Page>
          </div>
        )}
      </Fragment>
    );
  }
}
export default RushNews;

const TrWrapper = styled.tr`
  cursor: default;

  &.helperContainerClass {
    border: 1px solid #efefef;
    box-shadow: 0 5px 5px -5px rgba(0, 0, 0, 0.2);
    background-color: rgba(0, 125, 255, 0.2);
    border-radius: 3px;
    table-layout: fixed;

    &:active {
      cursor: grabbing;
    }

    & > td {
      width: 4%;
      vertical-align: top;
      padding: 0.5rem;
    }

    td > div {
      padding: 5px;
      display: flex;
    }

    div > div {
      flex: 1;
      width: 200px;
    }
  }
`;

const RowHandler = SortableHandle(() => (
  <p>
    <GrDrag size="25px" />
  </p>
));

const TableRow = ({ Image, Name, Url, Action }) => {
  return (
    <TrWrapper>
      <td>
        <RowHandler />
      </td>
      <td>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, width: "200px" }}>{Image}</div>
        </div>
      </td>
      <td>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, width: "200px" }}>
            <p style={{ overflowX: "hidden" }}>{Name}</p>
          </div>
        </div>
      </td>
      <td>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, width: "200px" }}>
            <p style={{ overflowX: "hidden" }}>{Url}</p>
          </div>
        </div>
      </td>
      <td>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, width: "200px" }}>{Action}</div>
        </div>
      </td>
    </TrWrapper>
  );
};
